export const pushToDataLayer = (data: Record<any, any>) => {
  if (typeof window !== "undefined" && window.dataLayer) {
    window.dataLayer.push(data);
  } else {
    console.warn("dataLayer not found", data?.event || "No event specified");
  }
};
